<script>
import CandelaComponent from '@/components/CandelaComponent'
import {bin, histogram} from '@/components/plots/atoms'

export default {
  computed: {
    bins() {
      return bin(this.x, this.y, this.bin_count)
    },
    colors() {
      return this.y.data.map((x, i) => {
        return this.settings.plot_colors.value(i)
      })
    },
    histograms() {
      return histogram(this.bins.binned, this.axis_x, this.axis_y)
    },
    x_data() {
      return this.bins.x_data
    },
    y_data() {
      return this.bins.y_data
    }
  },
  extends: CandelaComponent,
  data() {
    return {
      axis_x: null,
      axis_y: null
    }
  },
  methods: {
    update(axes) {
      this.axis_x = axes.x
      this.axis_y = axes.y
    }
  },
  name: 'candela-histogram',
  props: {
    bin_count: {type: Number, default: () => 5},
    x: {type: Object, default: () => ({})},
    y: {type: Object, default: () => ({})}
  }
}
</script>

<template>
<div class='candela-component'>
  <candela-plot ref='plot' :id='id' :frame='frame' @update='update'>
    <candela-axis slot='axis_x' v-if='x_data' v-bind='x_data'/>
    <candela-axis slot='axis_y' v-if='y_data' v-bind='y_data'/>

    <g slot='background'>
      <candela-grid-lines v-if='settings.show_grid.value'
        :axis_x='axis_x' :axis_y='axis_y'/>
    </g>

    <g slot='content'>
      <g v-for='(h, i) in histograms' :key='i'>
        <rect v-for='(bar, j) in h' :key='j'
          class='histogram-bar' :fill='colors[i]'
          :width='bar.width' :height='bar.height'
          :x='bar.x || 0' :y='bar.y || 0'/>
      </g>
    </g>
    <div slot='bottom-content'>
      <candela-legend v-if='y && y.index && settings.show_legend.value'
        :colors='colors' :index='y.index' :title='y.variable'/>
    </div>
  </candela-plot>
</div>
</template>
